import {
  ApplicationConfig,
  APP_INITIALIZER,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzModalService } from 'ng-zorro-antd/modal';
import { RolePermissionService } from './core/services/role-permission.service';
import { AuthService } from './core/services/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideAngularSvgIcon(),
    provideAnimations(),
    provideNzConfig({
      message: { nzMaxStack: 1 },
    }),
    importProvidersFrom(NzDrawerModule),
    NzModalService,
    {
      provide: APP_INITIALIZER,
      useFactory:
        (rbacService: RolePermissionService, auth: AuthService) => () => {
          const role = localStorage.getItem('user_role');
          if (role) {
            try {
              const roles = auth.decryptData(role);
              if (roles && Array.isArray(roles)) {
                return rbacService.loadPermissions(roles).toPromise();
              }
            } catch (error) {
              console.warn('Failed to decrypt user role data:', error);
              localStorage.removeItem('user_role');
            }
          }
          return Promise.resolve();
        },
      deps: [RolePermissionService, AuthService],
      multi: true,
    },
  ],
};
